export default {"src":"/_next/static/media/DOW.182206c6.svg","height":18,"width":18};